module.exports = __webpack_public_path__ + "img/image-18.59b4aa23.jpg";